<template>
    <div>
        <b-form-group label="Question" label-for="question">
            <editor-menu-bar :editor="editor" v-slot="{ commands, isActive, getMarkAttrs, focused }">
                <div class="menubar mb-1" :class="{'is-focused': focused}">
                    <b-btn-group>
                        <b-btn variant="light" @click="addBlank" content="Insert Blank" v-tippy="{placement: 'top'}">
                            <font-awesome-icon :icon="['far', 'horizontal-rule']" />
                        </b-btn>
                        <b-btn variant="light" @click="show_add_related_media_modal = true" content="Add SBP Image" v-tippy="{placement: 'top'}">
                            SBP
                        </b-btn>
                        <b-btn variant="light" @click="commands.createTable({rowsCount: 3, colsCount: 3, withHeaderRow: false })" content="Insert Table" v-tippy="{placement: 'top'}">
                            <font-awesome-icon :icon="['far', 'table']" />
                        </b-btn>
                    </b-btn-group>
                    <b-dropdown text="Table Actions" class="menubar mb-1" v-if="isActive.table()">
                        <b-dropdown-item @click="commands.deleteTable">Delete Table</b-dropdown-item>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item @click="commands.addRowBefore">Add Row Before</b-dropdown-item>
                        <b-dropdown-item @click="commands.addRowAfter">Add Row After</b-dropdown-item>
                        <b-dropdown-item @click="commands.deleteRow">Delete Row</b-dropdown-item>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item @click="commands.addColumnBefore">Add Column Before</b-dropdown-item>
                        <b-dropdown-item @click="commands.addColumnAfter">Add Column After</b-dropdown-item>
                        <b-dropdown-item @click="commands.deleteColumn">Delete Column</b-dropdown-item>
                    </b-dropdown>
                </div>
            </editor-menu-bar>

            <editor-content ref="editor-content" class="editor-content" :editor="editor"/>

            <b-form-invalid-feedback class="mb-2" :state="validating && !editable_content.question ? false : null">
                Question is required
            </b-form-invalid-feedback>

        </b-form-group>

        <b-form-group v-if="editable_content.blanks && editable_content.blanks.length" label="Blanks" label-for="blanks">
            <b-list-group>
                <b-list-group-item v-for="(blank, index) in editable_content.blanks" :key="index">

                    <span v-b-toggle="'blank' + blank.blank_id" class="collapse-icon text-dark">
                        <span class="open">
                            <font-awesome-icon :icon="['fas', 'caret-down']" fixed-width />
                        </span>
                        <span class="closed">
                            <font-awesome-icon :icon="['fas', 'caret-right']" fixed-width />
                        </span>
                        <span class="mx-1" :class="{'text-danger': validating && !blank.answer}">{{blank.blank_id}}</span>
                    </span>

                    <b-collapse :id="'blank' + blank.blank_id">
                        <b-form-group v-if="!blank.options || blank.options && !blank.options.length" label-for="answer">
                            Answer: <sup><font-awesome-icon :icon="['fad', 'info-circle']" content="Student must type the exact answer, including caps." class="text-info" v-tippy /></sup>
                            <b-form-input v-model="blank.answer" :state="validating && !blank.answer ? false : null" />

                            <b-form-invalid-feedback :state="validating && !blank.answer ? false : null">
                                Answer is required
                            </b-form-invalid-feedback>
                        </b-form-group>

                        <b-form-group label-for="options" class="mb-0">
                            <label>
                                Options <sup><font-awesome-icon :icon="['fad', 'info-circle']" content="Students will select the answer from a list of options" class="text-info" v-tippy /></sup>
                            </label>

                            <b-alert variant="warning" :show="!blank.options || blank.options && !blank.options.length" class="mb-2">
                                0 Options
                            </b-alert>

                            <div v-if="blank.options && blank.options.length" class="mb-2">
                                <div v-for="(option, index) in blank.options" :key="index" class="mb-1">
                                    <b-input-group>
                                        <b-input-group-prepend is-text>
                                            <b-form-radio
                                                v-model="blank.answer"
                                                :value="option.option"
                                                :state="validating && blank.answer == null ? false : null"
                                                :disabled="!option.option"
                                                class="mr-n2"
                                            >
                                                <span class="sr-only"></span>
                                            </b-form-radio>
                                        </b-input-group-prepend>
                                        <b-form-input v-model="option.option" :state="validating && !option.option ? false : null" v-focus/>
                                        <b-input-group-append>
                                            <b-btn variant="danger" @click.prevent="removeOption(blank, index)">
                                                <font-awesome-icon :icon="['far', 'minus']" />
                                            </b-btn>
                                        </b-input-group-append>
                                    </b-input-group>

                                    <b-form-invalid-feedback :state="validating && !option.option ? false : null">
                                        Option text is required
                                    </b-form-invalid-feedback>
                                </div>

                                <b-form-invalid-feedback :state="validating && blank.answer == null ? false : null">
                                    Answer is required
                                </b-form-invalid-feedback>
                            </div>
                            <b-btn
                                size="sm" 
                                variant="outline-primary" 
                                @click.prevent="addOption(blank)"
                            >
                                <font-awesome-icon :icon="['fad', 'plus-square']" /> Add Option
                            </b-btn>
                        </b-form-group>
                    </b-collapse>
                </b-list-group-item>
            </b-list-group>
        </b-form-group>

        <b-form-invalid-feedback :state="validating && blankWithoutAnswer ? false : null" class="mb-3">
            Answer is required for all blanks
        </b-form-invalid-feedback>

        <b-form-invalid-feedback class="mb-2" :state="validating && (!editable_content.blanks || editable_content.blanks && !editable_content.blanks.length) ? false : null">
            At least 1 blank is required
        </b-form-invalid-feedback>

        <add-related-media-modal
            v-model="show_add_related_media_modal"
            :type="'image'"
            @link="createSbpImgNode"
            @hide="show_add_related_media_modal = false"
        />

    </div>
</template>

<style lang="scss">

</style>

<style lang="scss" scoped>
.prompt {
    min-height: 6rem;
}
</style>

<script>
import { mapState } from 'vuex'

import {
    Editor,
    EditorContent,
    EditorMenuBar
} from 'tiptap'
import { 
    Table, 
    TableCell, 
    TableHeader, 
    TableRow
} from 'tiptap-extensions'

import BlankNode from '@/common/tiptap/blank-node'
import AddRelatedMediaModal from '@/components/modals/article/related_media/AddRelatedMediaModal'
import MerlinImageNode from '@/common/tiptap/merlin-image-node'
import SbpImageNode from '@/common/tiptap/sbp-image-node'

export default {
    data: () => ({
        options: [],
        show_add_related_media_modal: false,
        editor: null,
        editable_content: {},
        selected_text: null
    }),
    props: [
        'question'
    ],
    components: {
        EditorContent,
        EditorMenuBar,
        AddRelatedMediaModal
    },
    computed: {
        ...mapState({
            validating: state => state.utilities.validating
        }),
        blankWithoutAnswer () {
            let blankWithoutAnswer = false

            if (this.editable_content.blanks) {
                _.forEach(this.editable_content.blanks, blank => {
                    if (!blank.answer) {
                        blankWithoutAnswer = true
                    }
                })
            }

            return blankWithoutAnswer
        }
    },
    watch: {
        question: {
            handler (question) {
                if (question && question.content) {
                    this.editable_content = question.content
                }
            },
            deep: true,
            immediate: true
        },
        editable_content: {
            handler (editable_content) {
                if (editable_content) {
                    this.$set(this.question, 'content', editable_content)

                    _.forEach(editable_content.blanks, blank => {
                        if (blank.options) {
                            this.$set(blank, 'options', blank.options)
                        }
                    })
                }
            },
            deep: true
        }
    },
    methods: {
        addBlank () {
            // let blank_id = Math.floor(Math.random() * 100000)

            let blank_id = null

            if (!this.editable_content.blanks) {
                this.$set(this.editable_content, 'blanks', [])
            }

            blank_id = this.editable_content.blanks.length + 1

            const { selection, state } = this.editor
            const { from, to } = selection

            this.selected_text = state.doc.textBetween(from, to, ' ')

            this.editor.commands.blank_node({
                blank_id: blank_id,
                answer: this.selected_text,
                class: 'blank'
            })
        },
        addOption (blank) {
            if (!blank.options) {
                this.$set(blank, 'options', [])
            }

            if (blank.answer &&! blank.options.length) {
                blank.options.push({
                    option: blank.answer
                })
            } else {
                blank.options.push({})
            }
        },
        removeOption (blank, index) {
            blank.options.splice(index, 1)
        },
        optionWithValue (blank) {
            let optionWithValue = false

            _.forEach(blank.options, option => {
                if (option.option) {
                    optionWithValue = true
                }
            })

            return optionWithValue
        },
        createSbpImgNode (asset, width, align) {

            let relatedmediaid = null
            let caption = null
            let credit = null
            let description = null
            let src = null
            let alt = null

            if (asset.id) {
                relatedmediaid = asset.id
            }

            if (asset.caption) {
                caption = asset.caption
            }

            if (asset.credit) {
                credit = asset.credit
            }

            if (asset.description) {
                description = asset.description
            }
            if (asset.alt) {
                alt = asset.alt
            }
            if (asset.url) {
                src = asset.url
            }

            if (width) {
                width = width + '%'
            }

            this.editor.commands.sbp_image_node({
                relatedmediaid: relatedmediaid,
                align: align,
                alt: alt,
                caption: caption,
                credit: credit,
                description: description,
                src: src,
                width: width,
            })

            this.$emit('update')

            this.show_sbp_image_modal = false
            this.show_add_related_media_modal = false
        }
    },
    mounted () {
        this.editor = new Editor({
            extensions: [
                new BlankNode(),
                new MerlinImageNode(),
                new SbpImageNode(),
                new Table(),
                new TableCell(),
                new TableHeader(),
                new TableRow(),
            ],
            onFocus: () => {

            },
            onUpdate: (value) => {
                let question = value.getHTML()

                if (question) {
                    this.$set(this.editable_content, 'question', question)

                    let parser = new DOMParser()
                    let html = parser.parseFromString(question, 'text/html')

                    let blanksCollection = html.getElementsByTagName('blank')

                    // let blanksArray = [...blanksCollection]

                    let blanksArrayMap = _.map(blanksCollection, blank => {
                        let blank_id = blank.getAttribute('blank_id')

                        let selected_text = null

                        if (this.selected_text) {
                            selected_text = this.selected_text
                        }

                        if (!this.editable_content.blanks) {
                            this.$set(this.editable_content, 'blanks', [])
                        }

                        if (!_.find(this.editable_content.blanks, {blank_id: blank_id})) {
                            this.editable_content.blanks.push({
                                blank_id: blank_id,
                                options: [{ option: selected_text }],
                            })
                        }

                        return {
                            blank_id: blank_id
                        }
                    })

                    if (this.editable_content.blanks && this.editable_content.blanks.length) {
                        _.forEach(this.editable_content.blanks, (blank, index) => {
                            let blank_id = null

                            if (blank && blank.blank_id) {
                                blank_id = blank.blank_id
                            }

                            if (!_.find(blanksArrayMap, {blank_id: blank_id})) {
                                this.editable_content.blanks.splice(index, 1)
                            }
                        })
                    } else {
                        this.$set(this.editable_content, 'blanks', [])
                    }
                }
            }
        })

        if (this.question.content && this.question.content.question) {
            this.editor.setContent(this.question.content.question)
        }
    },
    beforeDestroy () {
        if (this.editor) {
            this.editor.destroy()
        }
    }
}
</script>
